<template>
  <header class="header" :style="sereenWidth > 800 ? '' : 'height: 200px;'">
    <audio :src="mus" preload loop ref="MusicPlay"></audio>
    <img class="music" :style="isPlay ? 'animation-name: music;' : ''" @click="musicPausePlay" src="../../assets/music.png" alt="" :title="isPlay ? '暂停' : '播放'">
    <div style="text-align: center;">
      <img class="user-img" src="../../assets/user.jpg" alt="" :style="sereenWidth > 800 ? '' : 'margin-top: 10px;'">
      <h3 style="color: #948c76; margin-top: 10px;">
        <span style="background-color: #fdf4e8; padding: 5px 15px; border-radius: 10px;">F F Blog</span>
      </h3>
    </div>
    <div class="header-bar">
      <template v-for="(item, index) in items">
        <div :style="sereenWidth > 800 ? '' : 'font-size: 15px'" :class="onRoutes == item.index ? 'active-bar' : 'add-style'" :key="index" @click="handleBar(item, index)">{{item.title}}</div>
      </template>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'vHeader',
    props: {
      sereenWidth: Number
    },
    data () {
      return {
        isPlay: false,
        mus: require('../../assets/music/my_dream.mp3'),
        indexNum: this.$route.path.replace('/', '') || 'index',
        items: [
          {
            index: 'index',
            title: '首页'
          },
          {
            index: 'introduction',
            title: '简介'
          },
          {
            index: 'note',
            title: '笔记'
          },
          {
            index: 'message',
            title: '留言'
          },
          {
            index: 'caipiao',
            title: '彩票'
          }
        ]
      }
    },

    mounted () {
      // console.log(this.$route.path.replace('/', ''), this.indexNum)
    },

    methods: {
      handleBar (item, index) {
        if(item.index != this.indexNum) {
          this.indexNum = item.index
          if(item.index == 'index') {
            this.$router.replace('/')
          } else {
            this.$router.replace('/' + item.index)
          }
        } else if (item.index == 'note') {
          if(this.$route.path.replace('/', '') != 'note') this.$router.replace('/' + item.index)
        } else if (item.index == 'index') {
          if(this.onRoutes != 'index') this.$router.replace('/')
        }
      },

      musicPausePlay () {
        this.isPlay = !this.isPlay
        if(this.isPlay) {
          this.$refs.MusicPlay.play()
        } else {
          this.$refs.MusicPlay.pause()
        }
      },


    },

    computed: {
      onRoutes() {
        return this.$route.path.replace('/', '') || 'index'
      }
    },
  }
</script>

<style>
  .header {
    position: relative;
    height: 300px;

    /* background-size: 100% 100%; */
  }

  .header .music {
    position: fixed;
    z-index: 99;
    top: 20px;
    left: 30px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    animation-duration: 3s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    transform-origin: center center;
  }

  @keyframes music {
    0%{-webkit-transform:rotate(0deg);}
    25%{-webkit-transform:rotate(90deg);}
    50%{-webkit-transform:rotate(180deg);}
    75%{-webkit-transform:rotate(270deg);}
    100%{-webkit-transform:rotate(360deg);}
  }

  .header .user-img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-top: 50px;
  }

  .header-bar {
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: #230aad;
    color: #ffffff;
    position: absolute;
    bottom: 0;
  }

  .header-bar div {
    padding: 8px 20px;
    letter-spacing: 2px;
    font-size: 20px;
    cursor: pointer;
    box-sizing: border-box;
  }

  .header-bar .active-bar {
    background-color: #ffffff;
    color: #948c76;
    border-top: 4px solid #f77825;
  }

  .header-bar div:hover {
    background-color: #ffffff;
    color: #948c76;
    border-top: 4px solid #f77825;
  }

  .add-style {
    border-top: 4px solid transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue